import { ThemeProvider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { premiumTheme } from '../app/theme';
import useTracker from '../hooks/tracker';

import { Button } from './button';

function UpgradeOfferButton({
  size,
  offer,
  context,
  disabled,
  onClick,
}: {
  context: string;
  disabled?: boolean;
  offer?: 'standard' | 'premium';
  // When provided, the button performs this action directly instead of linking to /admin/offers
  // — used when the caller already knows which offer/price to subscribe to.
  onClick?: () => void;
  size?: 'small' | 'medium';
}): React.JSX.Element {
  const { t } = useTranslation();
  const { trackEvent } = useTracker();

  return (
    <ThemeProvider theme={premiumTheme}>
      <Button
        disabled={disabled}
        size={size || 'large'}
        variant="contained"
        {...(onClick
          ? {
              onClick: () => {
                trackEvent('Upgrade Offer Button Clicked', { context });
                onClick();
              },
            }
          : {
              component: Link,
              onClick: () => trackEvent('Upgrade Offer Button Clicked', { context }),
              to: '/admin/offers',
            })}
      >
        {offer === 'premium'
          ? t('companies.actions.upgrade_offer_premium')
          : offer === 'standard'
            ? t('companies.actions.upgrade_offer_standard')
            : t('companies.actions.upgrade_offer')}
      </Button>
    </ThemeProvider>
  );
}

export default UpgradeOfferButton;
